"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var VLibras = /*#__PURE__*/function (_React$Component) {
  _inherits(VLibras, _React$Component);

  var _super = _createSuper(VLibras);

  function VLibras(props) {
    var _this;

    _classCallCheck(this, VLibras);

    _this = _super.call(this, props);
    _this.widgetSrc = 'https://vlibras.gov.br/app';
    _this.scriptSrc = 'https://vlibras.gov.br/app/vlibras-plugin.js';
    _this.script = null;
    return _this;
  }

  _createClass(VLibras, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      this.script = document.createElement('script');
      this.script.src = this.scriptSrc;
      this.script.async = true;

      this.script.onload = function (load) {
        // @ts-ignore: Unreachable code error
        new window.VLibras.Widget(_this2.widgetSrc);
      };

      document.head.appendChild(this.script);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();
    }
  }, {
    key: "render",
    value: function render() {
      return (// @ts-ignore: Unreachable code error
        React.createElement("div", {
          vw: "true",
          className: "enabled"
        }, React.createElement("div", {
          "vw-access-button": "true",
          className: "active"
        }), React.createElement("div", {
          "vw-plugin-wrapper": "true"
        }, React.createElement("div", {
          className: "vw-plugin-top-wrapper"
        })))
      );
    }
  }]);

  return VLibras;
}(React.Component);

exports.default = VLibras;